import { render, staticRenderFns } from "./WowzaLivestreamCreateForm.vue?vue&type=template&id=22ec2d8d&scoped=true"
import script from "./WowzaLivestreamCreateForm.vue?vue&type=script&lang=js"
export * from "./WowzaLivestreamCreateForm.vue?vue&type=script&lang=js"
import style0 from "./WowzaLivestreamCreateForm.vue?vue&type=style&index=0&id=22ec2d8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22ec2d8d",
  null
  
)

export default component.exports